export const common = {
  // Login Page
  posSystemAccess: 'POS System Access',
  wordpressUsername: 'WordPress Username',
  username: 'Username',
  enterUsername: 'Enter your username',
  password: 'Password',
  enterPassword: 'Enter your application password',
  accessPosSystem: 'Access POS System',
  authenticating: 'Authenticating...',
  useCredentials: 'Use your administrator or shop manager credentials',
  invalidCredentials: 'Invalid username or password',
  connectionError: 'Connection error. Please check your internet connection and try again.',

  // Header
  pointOfSale: 'Point of Sale',
  notSet: 'Karvasla',
  logout: 'Store - Tbilisi',

  // Product Search
  searchProducts: 'Search products',
  search: 'Search',

  // Product Brands
  allBrands: 'All Brands',

  // Product Grid
  noProducts: 'No products found',
  tryDifferent: 'Try a different search term or filter',
  addToCart: 'Add to Cart',
  adding: 'Adding...',
  outOfStock: 'Out of Stock',
  outOfStockOn: 'Out of Stock: On',
  outOfStockOff: 'Out of Stock: Off',
  showOutOfStock: 'Show out of stock',
  hideOutOfStock: 'Hide out of stock',
  loadingProducts: 'Loading products...',
  loading: 'Loading...',
  stock: 'Stock',
  each: 'each',
  more: 'More',
  less: 'Less',

  // Custom Product
  addCustomProduct: 'Add Custom Product',
  createOneTimeProduct: 'Create a one-time sale product',
  createCustomProduct: 'Create Custom Product',
  productName: 'Product Name',
  enterProductName: 'Enter product name',
  price: 'Price',
  enterSku: 'Enter SKU',
  productNameRequired: 'Product name is required',
  validPriceRequired: 'Valid price is required',
  skuRequired: 'SKU is required',

  // Cart
  currentOrder: 'Current Order',
  customer: 'Customer',
  selectCustomer: 'Select Customer',
  emptyCart: 'Your cart is empty',
  startAdding: 'Start adding products to begin',
  clearCart: 'Clear Cart',
  cart: 'Cart',
  walkInCustomer: 'Walk-in Customer',
  lookup: 'Lookup',
  changeCustomer: 'Change',

  // Checkout Controls
  subtotal: 'Subtotal',
  total: 'Total',
  items: 'items',
  completeOrder: 'Complete Order',
  printReceipt: 'Print Receipt',
  discount: 'Discount',
  applyDiscount: 'Apply Discount',
  discountAmount: 'Discount Amount',
  paymentMethod: 'Payment Method',
  cash: 'Cash',
  card: 'Card',
  bank: 'Bank',
  transfer: 'Bank Transfer',
  cashReceived: 'Cash Received',
  change: 'Change',
  insufficient: 'Insufficient',
  processing: 'Processing...',
  addItemsToCheckout: 'Add items to checkout',
  cartEmpty: 'Cart is empty',
  selectPaymentMethod: 'Please select a payment method',
  cashReceivedMustBeGreater: 'Cash received must be greater than or equal to total',
  failedCreateOrder: 'Failed to create order',
  failedProcessOrder: 'Failed to process order. Please try again.',

  // Customer Lookup
  customerLookup: 'Customer Lookup',
  searchCustomers: 'Search customers by name, email, or phone...',
  noCustomers: 'No customers found',
  tryDifferentSearch: 'Try a different search term',
  select: 'Select',
  closeExistingOrderModal: 'Close',
  createNewCustomer: 'Create New Customer',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  phone: 'Phone',
  cancel: 'Cancel',
  create: 'Create',
  creating: 'Creating...',
  addNewCustomer: 'Add New Customer',
  heardAboutUsQuestion: 'From where did you hear about us?',
  heardAboutInstagram: 'Instagram',
  heardAboutTikTok: 'Tik-tok',
  heardAboutFacebook: 'Facebook',
  heardAboutAds: 'Ads',
  heardAboutRecommendation: 'Recommendation',
  heardAboutSearch: 'Search',
  heardAboutAI: 'AI',
  heardAboutExistingCustomer: 'Existing Customer',
  heardAboutNotDefined: 'Not Defined',
  searchByName: 'Search by name, email, or phone',
  spent: 'Spent',
  orders: 'Orders',
  phoneNumber: 'Phone Number',
  address: 'Address',
  city: 'City',
  personalNumber: 'Personal Number / ID Code',
  enterFirstName: 'Enter first name',
  enterLastName: 'Enter last name',
  enterEmail: 'Enter email address',
  enterPhone: 'Enter phone number',
  enterAddress: 'Enter street address',
  enterCity: 'Enter city',
  enterPersonalNumber: 'Enter personal number or ID code',
  backToSearch: 'Back to Search',
  createCustomer: 'Create Customer',
  retry: 'Retry',
  failedLoadCustomers: 'Failed to load customers',
  failedConnectStore: 'Failed to connect to store',

  // Order Complete
  orderCompleted: 'Order Completed',
  orderNumber: 'Order Number',
  orderTotal: 'Order Total',
  backToStore: 'Back to Store',
  nextOrder: 'Next Order',

  // Battery Tier Modal
  configureProduct: 'Configure Product',
  batteryHealth: 'Battery Health',
  addOns: 'Add-ons',
  noAdditionalOptions: 'No additional options available for this product',
  markAsGift: 'Mark as Gift (Free)',
  gift: 'Gift',
  battery: 'Battery',
  newBattery: 'New Battery',
  preorder: 'Preorder',
  markAsPreorder: 'Mark this item as preorder',
  customPrice: 'Customize Price',
  originalPrice: 'Original price',
  addon: 'Add-on',

  // Currency
  currency: '₾',

  // Additional
  cashier: 'Cashier',
  pointOfSaleSystem: 'Point of Sale System',
  karvasla: 'Karvasla',
  mainBranchTbilisi: 'Store - Tbilisi',
  yourCartIsEmpty: 'Your cart is empty',
  addProductsToGetStarted: 'Add products to get started',
  chooseExistingOrder: 'Choose existing order',
  linkedParentOrder: 'Linked parent',
  existingOrder: 'Existing order',
  clearLinkedOrder: 'Clear linked order',
  parentOrder: 'Parent order',
  chooseExistingOrderTitle: 'Choose existing order',
  chooseExistingOrderHelp: 'The next sale will be grouped under the selected order after checkout.',
  close: 'Close',
  searchExistingOrderPlaceholder: 'Search order number, customer, receipt ID...',
  typeAtLeastTwoCharacters: 'Type at least 2 characters.',
  searching: 'Searching...',
  noMatchingOrdersFound: 'No matching orders found.',
  itemsShort: 'items',
  chooseSalesperson: 'Choose salesperson',
  chooseSalespersonHelp: 'Select who made this sale before finishing the order.',
  salespersonRequired: 'Salesperson is required',
  continueOrder: 'Continue',
  loadingSalespersons: 'Loading salespersons...',
  noSalespersonsFound: 'No salespersons found',

  // Customer Display
  welcomeToStore: 'Welcome',
  waitingForCashier: '',
  yourOrder: 'Your Order',
  quantity: 'Quantity',
  selectBank: 'Select Bank',
  cardPayment: 'Card Payment',
  insertOrTapCard: 'Insert or Tap Card',
  paymentSuccess: 'Payment Successful',
  paymentFailed: 'Payment Failed',
  totalAmount: 'Total Amount',
  newCustomer: 'New Customer',
  orderComplete: 'Order Complete!',
  thankYouForShopping: 'Thank you for shopping!',
  pleaseTryAgain: 'Please try again or contact staff',
  tryAgain: 'Try Again',
  commission: 'Commission',
  continue: 'Continue',
  stop: 'Stop',
  customerDisplay: 'Customer Display',
  previewCustomerDisplay: 'Preview Customer Display',
  openCustomerDisplay: 'Open Customer Display',
  preview: 'Preview',
  hide: 'Hide',
  scanBarcode: 'Scan barcode',
  scannerReady: 'Scanner ready. Scan now.',
  scannerHint: 'Aim the scanner and wait for the beep. Press Esc to close.',
  barcodeNotFound: 'Barcode not found',
  barcodeTooSlow: 'Manual typing detected. Please scan again.',
  barcodeFound: 'Barcode found',
  customerEnteringDetails: 'Customer is entering details...',
  interrupt: 'Interrupt',
  paymentMethodComingSoon: 'Payment method coming soon',
  selectPaymentMethod2: 'Select Payment Method',
  selectInstallmentProvider: 'Select Installment Provider',
  chooseTerminal: 'Choose terminal',
  selected: 'Selected',
  back: 'Back',
  paymentProcessing: 'Processing payment',
  pleaseWait: 'Please wait for terminal response',

  // Customer Form
  fillCustomerDetails: 'Fill in customer details',
  personalInformation: 'Personal Information',
  contactInformation: 'Contact Information',
  addressInformation: 'Address Information',
  accountInformation: 'Account Information',
  company: 'Company',
  representativeFullName: 'Representative full name',
  companyName: 'Company name',
  companyIdentificationNumberFull: 'Company identification number',
  address1: 'Address 1',
  address2: 'Address 2',
  state: 'State/Region',
  postcode: 'Postcode',
  person: 'Person',
  personalIdentificationNumber: 'Personal Identification Number',
  companyIdentificationNumber: 'Company Identification Number',
  terminal: 'Terminal',
  terminalPayment: 'Terminal Payment',
  online: 'Online',
  onlinePayment: 'Online Payment',
  chooseCorrectWireBank: 'Choose the correct bank (BOG, TBC or Credo) and its matching QR/IBAN.',
};
